<template>
  <div>
    <div v-if="loading" class="page-loading">
      <Loading />
    </div>
    <div v-else>
      <div class="em-g p-20 bg-white rad-10">
        <header>{{ $t("Package.newPackages") }}</header>
        <div class="page-content center-form">
          <table class="table">
            <thead>
              <tr>
                <th>{{ $t("Package.packageTitle") }}</th>
                <th>{{ $t("Package.days") }}</th>
                <th>{{ $t("Package.price") }}</th>
                <th>{{ $t("Package.description") }}</th>
                <th>{{ $t("Package.action") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="pkg in packages" :key="pkg.id">
                <td>{{ pkg.title }}</td>
                <td>{{ pkg.days }}</td>
                <td>{{ formatCurrency(pkg.price) }}</td>
                <td>{{ pkg.description }}</td>
                <td>
                  <button
                    @click="purchasePackage(pkg.id)"
                    :disabled="loadingPackage === pkg.id"
                    class="btn-purchase"
                  >
                    <span v-if="loadingPackage === pkg.id"
                      >{{ $t("Custom.loading") }}...</span
                    >
                    <span v-else>{{ $t("Package.takeIt") }}</span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPackageWithOutFree, setPackage } from "@/api/package.api";
import apiClient from "@/axios"; // Ensure your Axios instance is properly configured
import Loading from "@/components/user/layout/LoadingComponent.vue"; // Ensure the path is correct

export default {
  name: "NewPackagesComponent",
  components: {
    Loading,
  },
  data() {
    return {
      loading: true, 
      packages: [], 
      loadingPackage: null,
    };
  },
  async mounted() {
    this.$emit("loading", true);
    await this.fetchNewPackages();
    this.$emit("loading", false);
  },
  methods: {
    async fetchNewPackages() {
      try {
        const response = await getPackageWithOutFree();
        if (response.data.status) {
          this.packages = response.data.data; 
        } else {
          console.error("Failed to fetch new packages:", response.data.msg);
        }
      } catch (error) {
        console.error("An error occurred while fetching new packages:", error);
      } finally {
        this.loading = false;
      }
    },
    async purchasePackage(packageId) {
      this.loadingPackage = packageId;
      try {
        const response = await setPackage(packageId);
        if (response.data.status) {
          await this.$store.dispatch("user/checkUserStatus", { force: true });
          this.$router.push("/dashboard");
        } else {
          alert("Satın alma işlemi başarısız: " + response.data.msg);
        }
      } catch (error) {
        console.error("An error occurred while purchasing the package:", error);
        alert(
          "Satın alma işlemi sırasında bir hata oluştu. Lütfen daha sonra tekrar deneyin."
        );
      } finally {
        this.loadingPackage = null;
      }
    },
    formatCurrency(value) {
      return `$${value}`;
    },
  },
};
</script>

<style scoped>
.em-g {
  margin: 0;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 8px 12px;
  border: 1px solid #ddd;
}

.page-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.btn-purchase {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.btn-purchase:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.btn-purchase:hover:enabled {
  background-color: #0056b3;
}
</style>
